import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Button, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";

import { setSearchTerm } from "../features/searchSlice";
import { setSelectedCategoryId } from "../features/categoriesSlice";

export default function Search({ fromNavBar = false }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tempSearchTerm, setTempSearchTerm] = useState("");

  const onSearch = (event) => {
    event.preventDefault();

    const trimmedSearchTerm = tempSearchTerm.trim();

    dispatch(setSearchTerm(trimmedSearchTerm));
    dispatch(setSelectedCategoryId(-1));
    navigate("/products");
  };

  const textFieldStyles = fromNavBar
    ? {
        mr: 2,

        "& .MuiInputLabel-root": {
          color: "#000000",
        },

        "& .MuiOutlinedInput-input": {
          color: "#000000",
        },

        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#000000",
        },

        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#000000",
          },

        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#D81B60",
            borderWidth: "2px",
          },

        "& .MuiInputLabel-root.Mui-focused": {
          color: "#D81B60",
        },
      }
    : {
        mr: 2,

        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#D81B60",
            borderWidth: "2px",
          },

        "& .MuiInputLabel-root.Mui-focused": {
          color: "#D81B60",
        },
      };

  return (
    <Box
      component="form"
      role="search"
      aria-label="חיפוש מוצרים באתר"
      onSubmit={onSearch}
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <TextField
        id="product-search"
        name="search"
        type="text"
        color="secondary"
        variant="outlined"
        label="חיפוש מוצרים"
        value={tempSearchTerm}
        onChange={(event) =>
          setTempSearchTerm(event.target.value)
        }
        autoComplete="off"
        inputProps={{
          "aria-label": "הקלדת שם מוצר לחיפוש",
        }}
        sx={textFieldStyles}
      />

      <Button
        type="submit"
        variant="contained"
        aria-label="ביצוע חיפוש מוצרים"
        title="חיפוש מוצרים"
        sx={{
          minWidth: 56,
          width: 56,
          height: 56,
          borderRadius: 1,
          backgroundColor: "#D81B60",
          boxShadow: "none",
          p: 0,

          "&:hover": {
            backgroundColor: "#AD1457",
            boxShadow: "none",
          },

          "&:focus-visible": {
            outline: "3px solid #111111",
            outlineOffset: "3px",
          },
        }}
      >
        <SearchIcon
          sx={{ fontSize: 30 }}
          aria-hidden="true"
          focusable="false"
        />
      </Button>
    </Box>
  );
}